import React from 'react';
import { getHamburgerHeaderIcon } from 'bootstrap/lib/utils/getHamburgerHeaderIcon';
import { getOwaMiniStrings } from 'owa-strings/owa-mini-strings';
import { HeaderIcons } from 'mini-header';
import { isMeControlEnabled } from 'mini-mecontrol/lib/utils/meControlCommonUtils';
import { isMultiAccountPopupEnabled } from 'multi-account/lib/utils/isMultiAccountPopupEnabled';
import { PersonaSize } from 'owa-persona';
import { UserPersonaControl } from 'mini-user-persona';

const styles = require('./HeaderContent.scss');

export interface LeftHeaderContentProps {
    navigationButtonRef?: React.RefObject<HTMLDivElement>;
    onOpenFolderPane?: (navigationButtonRef?: React.RefObject<any>) => void;
    ariaLabel?: string;
}

/**
 * Component for rendering the left header content.
 */
export const LeftHeaderContent = React.forwardRef((props: LeftHeaderContentProps) => {
    const { navigationButtonRef, onOpenFolderPane, ariaLabel } = props;
    const strings = getOwaMiniStrings();

    const hamburgerIcon = getHamburgerHeaderIcon(
        navigationButtonRef,
        onOpenFolderPane,
        strings.folderNavigationButtonAriaLabel
    );

    return isMultiAccountPopupEnabled() || isMeControlEnabled() ? (
        <HeaderIcons icons={[hamburgerIcon]} />
    ) : (
        <UserPersonaControl
            personaRef={navigationButtonRef}
            size={PersonaSize.extraSmall}
            onClickPersona={onOpenFolderPane}
            className={styles.userPersona}
            ariaLabel={ariaLabel}
            ariaHasPopup={true}
        />
    );
});
